import React from 'react'
import { Box, Grid } from 'components/Layout'
import { SCHEMA_PROPS, SCHEMA_TYPES } from 'constants/common'
import { COLOR_INTENT, SPACE } from 'Theme'
import { type NavigationItem } from 'types/graphql-generated'
import { DesktopSectionHeading as SectionHeading } from './DesktopSectionHeading'
import { HoverableLinkWithText } from './HoverableLinkWithText'
import { ItemWithImage } from './ItemWithImage'

const IMAGE_BASE_DIMENSIONS = {
  WIDTH: 168,
  HEIGHT: 108,
}

type NavigationItemWithImage = Required<NavigationItem>

export type Section = Omit<NavigationItemWithImage, 'children'> & {
  children: Array<NavigationItemWithImage>
}

export interface DesktopSectionOfSubItemsWithImagesProps {
  section: Section
}

export const DesktopSectionOfSubItemsWithImages: React.FC<
  React.PWC<DesktopSectionOfSubItemsWithImagesProps>
> = ({
  section: {
    title,
    children,
    cmsPage: { href },
  },
}) => (
  <Box mr={SPACE.PX_40} itemScope itemType={SCHEMA_TYPES.THING}>
    <meta
      itemProp={SCHEMA_PROPS.ALTERNATE_NAME}
      content="Navigation section with images"
    />
    <SectionHeading href={href} itemProp={SCHEMA_PROPS.NAME}>
      {title}
    </SectionHeading>
    <Grid
      gridRowGap={SPACE.PX_16}
      gridColumnGap={SPACE.PX_24}
      gridTemplateColumns="1fr 1fr"
      itemScope
      itemType={SCHEMA_TYPES.ITEM_LIST}
    >
      {children.map(
        (
          {
            id,
            attachment: { url, alt, name },
            cmsPage: { href: childHref },
            title: childrenTitle,
          },
          index
        ) => (
          <ItemWithImage
            key={id}
            baseWidth={IMAGE_BASE_DIMENSIONS.WIDTH}
            baseHeight={IMAGE_BASE_DIMENSIONS.HEIGHT}
            src={url}
            href={childHref}
            alt={alt}
            title={childrenTitle}
            name={name}
            index={index}
          />
        )
      )}
    </Grid>
    <Box mt={SPACE.PX_24}>
      <HoverableLinkWithText
        color={COLOR_INTENT.HEADER.VIEW_ALL.DEFAULT}
        href={href}
      >
        View more
      </HoverableLinkWithText>
    </Box>
  </Box>
)
